export let home_Tab_Groups = "cka7kd";
export let new_Group_Groups = "P$pxZ";
export let newMail_Button_Groups = "zGmQHc";
export let newEvent_Button_Groups = "OE1L3c";
export let newGroup_Button_Groups = "lbWeYd";
export let discover_Group_Groups = "sKt2Y";
export let discovergroup_Button_Groups = "Scrp2d";
export let view_Tab_Groups = "aKTcBe";
export let settings_Group_Groups = "sDuWke";
export let settings_Button_Groups = "lNZTFd";
export let immersivereader_Group_Groups = "vaKMNd";
export let immersivereader_Button_Groups = "WO9kAc";
export let print_Group_Groups = "KJd6_d";
export let print_Button_Groups = "XnnqP";
export let Actions_Groups = "qj_9Fb";
export let Modify_Groups = "H0xwqc";
export let editGroup_Button_Groups = "BQH6Fc";
export let addMembers_Button_Groups = "KXkgrb";
export let leaveGroup_Button_Groups = "apWBpb";
export let inviteOthers_Button_Groups = "EOa0fb";
export let viewInCalendar_Button_Groups = "ggHzmb";
export let viewCalendar_Groups = "_6B_Je";
export let help_Tab_Groups = "m4kzJe";
export let help_Group_Groups = "Gl_wic";
export let tools_Group_Groups = "UFtkv";
export default {home_Tab_Groups,new_Group_Groups,newMail_Button_Groups,newEvent_Button_Groups,newGroup_Button_Groups,discover_Group_Groups,discovergroup_Button_Groups,view_Tab_Groups,settings_Group_Groups,settings_Button_Groups,immersivereader_Group_Groups,immersivereader_Button_Groups,print_Group_Groups,print_Button_Groups,Actions_Groups,Modify_Groups,editGroup_Button_Groups,addMembers_Button_Groups,leaveGroup_Button_Groups,inviteOthers_Button_Groups,viewInCalendar_Button_Groups,viewCalendar_Groups,help_Tab_Groups,help_Group_Groups,tools_Group_Groups};